<template>
  <div>
    <!-- Select -->
    <v-select
      v-model="tempValue"
      :items="items"
      :label="label"
      :item-text="itemText"
      :item-value="itemValue"
      :disabled="disabled"
      outlined
      dense
      hide-details
      @change="onChange"
    />

    <!-- Confirm Dialog -->
    <v-dialog
      v-model="dialog"
      :persistent="false"
      max-width="420"
      @click:outside="cancel">
      <v-card>
        <v-card-title class="text-h6">
          {{ confirmTitle }}
        </v-card-title>

        <v-card-text>
          {{ confirmText }}
          <strong>{{ selectedText }}</strong>
          ?
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="cancel">
            {{ cancelText }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="confirm">
            {{ confirmButtonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ConfirmSelect',

  props: {
    value: {
      type: [String, null],
      default: null
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    itemText: {
      type: String,
      default: 'name'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    /* dialog texts */
    confirmTitle: {
      type: String,
      default: 'Confirm'
    },
    confirmText: {
      type: String,
      default: 'Are you sure you want to change to'
    },
    confirmButtonText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      dialog: false,
      tempValue: this.value,
      previousValue: this.value
    }
  },

  computed: {
    selectedText () {
      const found = this.items.find(
        (i) => i[this.itemValue] === this.tempValue
      )
      return found?.[this.itemText] ?? ''
    }
  },

  watch: {
    value (val) {
      this.tempValue = val
      this.previousValue = val
    }
  },

  methods: {
    onChange () {
      if (!this.previousValue) {
        this.confirm()
      } else {
        this.dialog = true
      }
    },

    cancel () {
      this.tempValue = this.previousValue
      this.dialog = false
    },

    confirm () {
      this.dialog = false
      this.$emit('input', this.tempValue) // v-model
      this.$emit('confirm', this.tempValue)
    }
  }
}
</script>
